<h3>Client Referral Tasks</h3>
<app-client-tasks-filter
  [filters]="filters"
  (filtersChange)="filtersChange($event)"
  [loading]="loading"
  [exportUrl]="exportUrl"
  [enableExport]="tasks.length > 0"
  [taskStatuses]="taskStatuses"
  [specialties]="specialties"
  [manufacturers]="manufacturers"
  [sources]="sources"
  [clients]="clients"
  [allowTaskIdSearch]="true"
  />
@if (!loading) {
  <div>
    @if (tasks.length > 0) {
      <div>
        <app-client-referral-task-list
          [tasks]="tasks"
          [paging]="paging"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          />
      </div>
    } @else {
      <section><p>There are no tasks.</p></section>
    }
  </div>
} @else {
  <mat-spinner diameter="30" />
}
